import { FC, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Grid, Tabs, Tab, Typography, Box } from "@mui/material";
import {
  ProfileBorderBox,
} from "../../../../../shared/components/profileComponents";
import useQuery from "../../../../../shared/components/hooks/useQuery";
import { FormViewContainer } from "../../../../../shared/components/formViewContainer";
import TabPanel from "../../../../../shared/components/tabpanel/tabpanel";
import FeeViewTerm from "./feeViewTerm";
import { ViewContainer } from "../../../../../shared/components/viewContainer";
import { TitleBarProps } from "../../../../../shared/components/titleBar";
import { formatAmountINR } from "../../../../../shared/utils/amountFormat";

const FeeView: FC = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };

  const { data } = useQuery(`/admin/Fees/${id}`, null);
  const feeData = (data as any)?.data || {};
  const feeTerms = feeData.feeTerms || [];

  const titleBar: TitleBarProps = {
    title: "Fee Structure Details",
    editCloseIcon: {
      visible: true,
      onClick: () => navigate("/fees/fee-structure"),
    },
  };

  return (
    <ProfileBorderBox>
      <ViewContainer titleBar={titleBar}>
        <Grid container spacing={0.25} px={4}>
          <Grid item xs={12}>
            <Box py={2}>
              {" "}
              <Typography variant="h6" gutterBottom>
                Class:{" "}
                <Typography component="span">
                  {feeData?.class?.displayName || "-"}
                </Typography>
              </Typography>
              <Typography variant="h6" gutterBottom>
                Academic Year:{" "}
                <Typography component="span">
                  {feeData?.academicYear?.name || "-"}
                </Typography>
              </Typography>
              <Typography variant="h6" gutterBottom>
                Annual Fee:{" "}
                <Typography
                  component="span"
                  color="primary.main"
                  fontWeight={700}
                >
                  {feeData?.feeTerms
                    ? formatAmountINR(
                        feeData.feeTerms.reduce(
                          (total: number, term: { amount: number }) =>
                            total + term.amount,
                          0
                        )
                      )
                    : "-"}
                </Typography>
              </Typography>
            </Box>
          </Grid>

          <Grid item xs={12}>
            <FormViewContainer
              tabs={
                <Tabs
                  value={activeTab}
                  onChange={handleTabChange}
                  sx={{ mb: 3 }}
                  textColor="primary"
                  indicatorColor="primary"
                >
                  {feeTerms.map((term: any) => (
                    <Tab
                      key={term.id}
                      label={term.name}
                      sx={{ textTransform: "none", fontWeight: 500 }}
                    />
                  ))}
                </Tabs>
              }
            >
              {feeTerms.map((term: any, index: number) => (
                <TabPanel key={term.id} value={activeTab} index={index}>
                  <FeeViewTerm term={term} />
                </TabPanel>
              ))}
            </FormViewContainer>
          </Grid>
        </Grid>
      </ViewContainer>
    </ProfileBorderBox>
  );
};

export default FeeView;
